.dropdown {
  @include mantine.general {
    box-shadow: var(--mantine-shadow-md);
    border: none;
    padding: mantine.rem(12px);
  }

  @include mantine.dark {
    background-color: var(--mantine-color-primary-9);
    color: var(--mantine-color-primary-7);
  }
}

.item {
  @include mantine.general {
    display: flex;
    align-items: center;
    padding: mantine.rem(12px);
    justify-content: center;
  }

  @include mantine.dark {
    &[data-hovered='true'],
    &:hover,
    &[aria-current='page'] {
      background-color: var(--mantine-color-primary-0);

      .itemSection {
        color: var(--mantine-color-secondary-7);
      }
    }
  }
}

.itemSection {
  @include mantine.general {
    svg {
      @extend %icon-sm;
    }
  }

  @include mantine.dark {
    background: var(--mantine-color-menuItemSection-0);
    color: var(--mantine-color-tertiary-0);
  }
}

.itemLabel {
  @include mantine.general {
    position: relative;
    top: mantine.rem(1px);

    @extend %text-md;
  }

  @include mantine.dark {
    color: var(--mantine-color-textInDark-0);
  }
}
